import { Component, Input, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCustomer } from 'src/app/registration/store/selectors/registration.selectors';

import { RegistrationState } from '../../models/registration.model';

@Component({
  selector: 'app-registration-grower',
  templateUrl: './grower.component.html',
  standalone: false,
})
export class GrowerComponent {
  private readonly store = inject<Store<RegistrationState>>(Store);

  @Input() editable: boolean;

  customer$ = this.store.select(selectCustomer);
}
